import { Box } from "@mui/material";
import Button from "@material-ui/core/Button";

export const getMatchActionButtons = ({
  row,
  onView,
  onAccept,
  onDecline,
  disabled = false
}) => {
  const isDeclined = row.status?.toLowerCase() === 'declined';
  const isActive = row.status?.toLowerCase() === 'active';
  const isPending = row.status?.toLowerCase() === 'pending';

  const buttonStyle = (color, isDisabled = false) => ({
    color,
    textDecoration: 'underline',
    background: 'none',
    boxShadow: 'none',
    minWidth: 0,
    padding: 0,
    opacity: isDisabled ? 0.5 : 1,
    cursor: isDisabled ? 'not-allowed' : 'pointer'
  });

  return (
    <Box display="flex" gap={2} justifyContent="center">
      <Button
        style={buttonStyle('#3096F5', isDeclined)}
        variant="text"
        onClick={() => onView(row)}
        disabled={isDeclined || disabled}
      >
        View Details
      </Button>
      {/**
       * Temporarily commenting out Accept/Decline buttons per request.
       * Restore the blocks below when needed.
       */}
      {/**
      {!isActive && (
        <Button
          style={buttonStyle('#3096F5', isDeclined)}
          variant="text"
          onClick={() => onAccept(row)}
          disabled={isDeclined || disabled}
        >
          Accept
        </Button>
      )}
      {!isActive && (
        <Button
          style={buttonStyle('#F44336', isDeclined)}
          variant="text"
          onClick={() => onDecline(row)}
          disabled={isDeclined || disabled}
        >
          Decline
        </Button>
      )}
      */}
    </Box>
  );
}; 